module.exports = __webpack_public_path__ + "static/media/grade1.e2ac88e8.jpg";